import { RecurrenceSettingsRoot } from '../../RecurrenceSettingsRoot'
import { RecurrenceTypeDropdown } from '../../RecurrenceTypeDropdown'

export function RecurrenceSettingsNoRepeat() {
  return (
    <RecurrenceSettingsRoot>
      <RecurrenceTypeDropdown />
    </RecurrenceSettingsRoot>
  )
}
